// Curated hero image options — verified Unsplash URLs (mountain streams + peaceful forests + trees)
// Delete /previews route after user picks one.

const OPTIONS = [
  // Mountain streams
  {
    id: "J",
    label: "J — River through green forest",
    note: "Flow • wilderness • depth",
    url: "https://images.unsplash.com/photo-1527489377706-5bf97e608852?fm=jpg&q=70&w=900&auto=format&fit=crop",
  },
  {
    id: "K",
    label: "K — Flowing water past trees",
    note: "Movement • softness • life",
    url: "https://images.unsplash.com/photo-1543310465-875e89ce22f6?fm=jpg&q=70&w=900&auto=format&fit=crop",
  },
  {
    id: "L",
    label: "L — River between mountains",
    note: "Perspective • openness • quiet",
    url: "https://images.unsplash.com/photo-1512036594830-51cea3a8df78?fm=jpg&q=70&w=900&auto=format&fit=crop",
  },
  {
    id: "M",
    label: "M — Green riverbank",
    note: "Living • lush • grounded",
    url: "https://images.unsplash.com/photo-1622025048802-54e8841fef43?fm=jpg&q=70&w=900&auto=format&fit=crop",
  },
  {
    id: "N",
    label: "N — Landscape river & trees",
    note: "Wide • breath • release",
    url: "https://images.unsplash.com/photo-1511523797961-8e5e11a48b5f?fm=jpg&q=70&w=900&auto=format&fit=crop",
  },
  {
    id: "O",
    label: "O — Multi-step waterfall",
    note: "Descent • gentle power • movement",
    url: "https://images.unsplash.com/photo-1508083535939-45a5fa9f0226?fm=jpg&q=70&w=900&auto=format&fit=crop",
  },

  // Peaceful forests
  {
    id: "P",
    label: "P — Sunlit forest with rays",
    note: "Warmth • hope • quiet reverence",
    url: "https://images.unsplash.com/photo-1448375240586-882707db888b?fm=jpg&q=70&w=900&auto=format&fit=crop",
  },
  {
    id: "Q",
    label: "Q — Forest at daytime (moody)",
    note: "Stillness • depth • enclosure",
    url: "https://images.unsplash.com/photo-1553755322-56baa43a31d7?fm=jpg&q=70&w=900&auto=format&fit=crop",
  },
  {
    id: "R",
    label: "R — Pathway between trees",
    note: "Journey • gentle beginning",
    url: "https://images.unsplash.com/photo-1519821172144-4f87d85de2a1?fm=jpg&q=70&w=900&auto=format&fit=crop",
  },
  {
    id: "S",
    label: "S — Pine forest in mist",
    note: "Soft • breath • softness",
    url: "https://images.unsplash.com/photo-1502252430442-aac78f397426?fm=jpg&q=70&w=900&auto=format&fit=crop",
  },
  {
    id: "T",
    label: "T — Woods in soft light",
    note: "Grounding • patience • hush",
    url: "https://images.unsplash.com/photo-1516214104703-d870798883c5?fm=jpg&q=70&w=900&auto=format&fit=crop",
  },
  {
    id: "U",
    label: "U — Tall trees at daytime",
    note: "Presence • scale • rootedness",
    url: "https://images.unsplash.com/photo-1425913397330-cf8af2ff40a1?fm=jpg&q=70&w=900&auto=format&fit=crop",
  },
];

const Previews = () => {
  return (
    <div
      style={{
        backgroundColor: "var(--mc-bg)",
        color: "var(--mc-ink)",
        minHeight: "100vh",
      }}
      data-testid="previews-page"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-12 py-14">
        <p
          className="text-sm tracking-eyebrow uppercase mb-4"
          style={{ color: "var(--mc-muted)" }}
        >
          Hero image options — Nature (v2)
        </p>
        <h1
          className="font-serif-display text-3xl md:text-4xl mb-3"
          style={{ color: "var(--mc-ink)" }}
        >
          Mountain streams &amp; peaceful forests
        </h1>
        <p
          className="text-base mb-10 max-w-2xl font-light"
          style={{ color: "var(--mc-ink-2)" }}
        >
          Twelve verified options at the site's vertical hero aspect ratio
          (4:5). Reply with a letter (J–U) and I'll swap it into the home hero.
        </p>

        <div className="space-y-16">
          <section>
            <h2
              className="font-serif-display text-2xl md:text-3xl mb-6"
              style={{ color: "var(--mc-ink)" }}
            >
              Mountain streams &amp; rivers
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
              {OPTIONS.slice(0, 6).map((o) => (
                <Card key={o.id} option={o} />
              ))}
            </div>
          </section>

          <section>
            <h2
              className="font-serif-display text-2xl md:text-3xl mb-6"
              style={{ color: "var(--mc-ink)" }}
            >
              Peaceful forests &amp; trees
            </h2>
            <div className="grid grid-cols-2 md:grid-cols-3 gap-6">
              {OPTIONS.slice(6).map((o) => (
                <Card key={o.id} option={o} />
              ))}
            </div>
          </section>
        </div>
      </div>
    </div>
  );
};

const Card = ({ option }) => (
  <div className="flex flex-col">
    <div
      className="aspect-[4/5] w-full overflow-hidden rounded-2xl"
      style={{ backgroundColor: "var(--mc-bg-3)" }}
    >
      <img
        src={option.url}
        alt={option.label}
        className="w-full h-full object-cover"
      />
    </div>
    <p
      className="mt-3 font-serif-display text-lg"
      style={{ color: "var(--mc-ink)" }}
    >
      {option.label}
    </p>
    <p className="text-xs mt-1" style={{ color: "var(--mc-muted)" }}>
      {option.note}
    </p>
  </div>
);

export default Previews;
